/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { Channel } from '../../../../core/entities/Channel';
import { RootState, useTivoSelector } from '../../../../core/tivo/tivo-redux-wrapper';
import { ONE_LINE_GUIDE_CHANNEL_SLICE_SIZE } from '../../../../store/videoplayerui/onelineguide/onelineguide.constants';
import { ChannelCell } from '../../../Guide/ChannelCell';
import { Highlight } from '../../../Highlight';

import './OneLineGuideChannelList.scss';

const OneLineGuideChannelList: FunctionComponent = () => {
    const { channels, selectedChannel, areChannelsSelected } = useTivoSelector(
        (state: RootState) => state.oneLineGuide,
    );

    const isPageFull = channels.length === ONE_LINE_GUIDE_CHANNEL_SLICE_SIZE;

    const isChannelSelected = (channel: Channel) =>
        selectedChannel && selectedChannel.channelId === channel.channelId;

    return (
        <div
            className={`one-line-guide-channels-list-container ${isPageFull ? 'has-gradient' : ''}`}
            data-testid="one-line-guide-channels-list"
        >
            {channels.map((channel) => (
                <div className="one-line-guide-channel-container" key={channel.channelId}>
                    <Highlight
                        isActive={isChannelSelected(channel)}
                        isGhostHighlightActive={isChannelSelected(channel) && !areChannelsSelected}
                        isHighlightVisible={isChannelSelected(channel)}
                        isPastGuideMode={false}
                    />
                    <ChannelCell channel={channel} />
                </div>
            ))}
        </div>
    );
};

export default OneLineGuideChannelList;
